import { Array, Predicate, Result } from 'effect';

import type { ProductLabel } from '../../../../../product/index';

import { promoFreeShipping } from '../../../../../config/order/promo';

const isFreeShipping = (label: ProductLabel): boolean => label.code === promoFreeShipping;

/**
 * The labels a product card shows as chips.
 *
 * The card drops the free-shipping chip. Its own text row already announces
 * free shipping, and a card with several chips hides the product image.
 */
export const cardLabels = (labels: readonly ProductLabel[]): ProductLabel[] =>
  Array.filter(labels, Predicate.not(isFreeShipping));

/**
 * The labels the product-detail gallery shows as chips.
 *
 * The gallery keeps the free-shipping chip and puts it first (issue 850).
 * The other labels keep their order from the API.
 */
export const galleryLabels = (labels: readonly ProductLabel[]): ProductLabel[] => {
  const [others, freeShipping] = Array.partition(labels, (label) =>
    isFreeShipping(label) ? Result.succeed(label) : Result.fail(label)
  );
  return [...freeShipping, ...others];
};
